import get from 'lodash/get'
import omit from 'lodash/omit'
import uniqBy from 'lodash/uniqBy'
import isArray from 'lodash/isArray'
import intersectionBy from 'lodash/intersectionBy'

import { brandsInSlice } from '../getAttributesBySlice/getAttributesBySlice'
import { getAirlinesForThisSlice } from '../../Slice/helpers'
import { cabinClassMap } from '../../../constants'
import { spiritBaseFareAncillaries } from './getSpiritAncillaries'

function brandById(id, brandReference) {
  return brandReference.find((b) => b.brandId === id)
}

export function mergeUpsellWithBrand(brandId, brandReference, upsellOption) {
  const brandRef = brandById(brandId, brandReference)
  let price = parseFloat(get(upsellOption, 'pricingInfo.totalFare'))
  price = price ? price.toFixed(2) : price

  return Object.assign({ brandId }, brandRef, omit(upsellOption, ['slice', 'pricingInfo']), {
    price,
  })
}

export function brandsForUpsellOptions(brandReference, upsellOptions = [], slices) {
  return upsellOptions.reduce((acc, upsell) => {
    const brands = get(upsell, 'slice', []).reduce((brandAcc, curSlice) => {
      const slice = slices.find((s) => s.uniqueSliceId === curSlice.uniqueSliceId)
      const upsellOption = mergeUpsellWithBrand(brandsInSlice(slice)[0], brandReference, upsell)

      if (upsellOption) {
        brandAcc.push(mergeUpsellWithBrand(brandsInSlice(slice)[0], brandReference, upsell))
      }
      return brandAcc
    }, [])

    return acc.concat(brands)
  }, [])
}

export function baseFareTileData(itinerary, brandReference, slice) {
  const brands = brandsInSlice(slice)
  const brandRef = brandById(brands[0], brandReference)
  let price = parseFloat(get(itinerary, 'totalPriceWithDecimal.price'))

  price = price ? price.toFixed(2) : price

  return Object.assign({}, brandRef, {
    token: itinerary.id,
    price,
  })
}

export function dedupBrandsInSlices(upsellsBySlice) {
  return upsellsBySlice.map((slice) => uniqBy(slice, 'brandId'))
}

export function dedupSlices(slices) {
  // By taking intersection of all slices and comparing its length against original slice length,
  // we can see if all slice arrays have the same elements.
  const intersection = intersectionBy(...slices, (x) => x.brandId)
  return intersection.length === slices[0].length ? [intersection] : slices
}

export function getFusedFareBrands(itinerary, brandReference) {
  if (!isArray(brandReference)) return []

  return get(itinerary, 'slices', []).reduce((baseFareSlices, curSlice) => {
    const airlines = getAirlinesForThisSlice(get(curSlice, 'segments', []), itinerary.airlines)

    let baseFare = baseFareTileData(itinerary, brandReference, curSlice)

    if (airlines.length === 1) {
      if (airlines[0].marketingAirline === 'NK' || airlines[0].name === 'F9') {
        baseFare = Object.assign({}, baseFare, spiritBaseFareAncillaries, {
          airlines,
        })
      } else if (baseFare.brandAttributes) {
        baseFare = Object.assign({}, baseFare, { airlines })
      } else {
        baseFare = null
      }
    }

    if (baseFare) {
      baseFareSlices.push(baseFare)
    }

    return baseFareSlices
  }, [])
}

export function truncateJetBlueNames(brandName) {
  const name = brandName && brandName.toLowerCase()

  if (name === 'blue non ref') {
    return 'Blue'
  }

  if (name === 'blue plus non ref') {
    return 'Blue Plus'
  }

  return brandName
}

export function getBasicFareTitle(upsells = [], upsellLength, searchRequestCabinClass) {
  if (upsellLength === 2 && upsells[0].name === upsells[1].name) {
    return upsells[0].name
  } else if (searchRequestCabinClass) {
    return cabinClassMap[searchRequestCabinClass]
  }

  return null
}
